import { render, staticRenderFns } from "./Hosting.vue?vue&type=template&id=6114abc8&"
import script from "./Hosting.vue?vue&type=script&lang=js&"
export * from "./Hosting.vue?vue&type=script&lang=js&"
import style0 from "./Hosting.vue?vue&type=style&index=0&id=6114abc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports